import API from '../modules/api';
import { Controller } from 'stimulus';
import Mustache from 'mustache';
import UrlHandler from '../modules/urlhandler';
import Map from '../modules/map';
import Baidu from '../modules/baidu';

const api = new API({ authStoreKey: 'person-filters' });
const URL = new UrlHandler();
const MAP = new Map();
const BAIDU = new Baidu();

const PARAMS = {
  personnel: {
    limit: 12,
    offset: 0,
    regions: URL.getParameter('region'),
    departments: URL.getParameter('departments')
  },
  offices: {
    regions: URL.getParameter('officeRegion')
  }
}

export default class extends Controller {
  static targets = [
    'region',
    'officeRegion',
    'departments',
    'personList',
    'personTemplate',
    'officeList',
    'officeTemplate',
    'showMore',
    'map',
    'baiduMap',
  ];

  /**
   * Automatically called when stimulus has initialized controller
   */
  initialize() {
    URL.addHandler(this.regionTarget);
    URL.addHandler(this.officeRegionTarget);
    URL.addHandler(this.departmentsTargets);

    if (!PARAMS.personnel.regions || PARAMS.personnel.regions.length === 0) {
      PARAMS.personnel.regions = [this.regionTarget.querySelector('option:nth-child(2)').value];
      this.regionTarget.selectedIndex = 1;
    }

    if (!PARAMS.personnel.departments || PARAMS.personnel.departments.length === 0) {
      PARAMS.personnel.departments = [this.departmentsTarget.value];
      this.departmentsTarget.checked = true;
    }

    this.getPersonData()
      .then(data => {
        this.processData(data, 'personnel');
      });

    this.getOfficeData()
      .then(data => {
        this.processData(data, 'offices')
      });
  }

  /**
   * Process data and pass it to render
   * @param {object} object data to process
   * @param {string} type type of the data
   * @param {boolean} append append result
   */
  processData(object, type, append = false) {
    if (type === 'personnel') {
      if (typeof object.result !== 'undefined' && typeof object.result.personnel !== 'undefined' && object.result.personnel.length > 0) {
        let button = this.showMoreTargets.filter(item => item.getAttribute('data-type') === type);
        if (button.length > 0) {
          button[0].style.display = object.result.pagination.hasMore ? 'inline-block' : 'none';
        }
        let array = object.result.personnel.map(item => {
          item.name = item.localizedName || item.firstName + ' ' + item.lastName;
          item.contentTheme = 'dark';
          return item;
        });
        this.render(this.personListTarget, this.personTemplateTarget, { items: array }, append);
      } else {
        this.render(this.personListTarget, this.personTemplateTarget, { items: [] }, append);
      }
    } else if (type === 'offices'){
      if (typeof object.result.offices !== 'undefined' && typeof object.result.offices !== 'undefined' && object.result.offices.length > 0) {
        let button = this.showMoreTargets.filter(item => item.getAttribute('data-type') === type);
        if (button.length > 0) {
          button[0].style.display = object.result.pagination.hasMore ? 'inline-block' : 'none';
        }
        let array = object.result.offices.map(item => {
          item.contentTheme = 'dark';
          return item;
        });
        this.renderMap({ items: array });
      } else {
        this.renderMap({ items: [] });
      }
    }
  }

  /**
   * For selects, buttons etc.
   */
  inputHandler() {
    PARAMS.personnel.offset = 0;
    PARAMS.offices.offset = 0;
    PARAMS.personnel.regions = this.regionTarget.value ? [this.regionTarget.value] : null;
    PARAMS.offices.regions = this.officeRegionTarget.value ? [this.officeRegionTarget.value] : null;
    PARAMS.personnel.departments = this.departmentsTargets.map((department) => {
      if (department.checked) {
        return department.value;
      }
    }).filter(Boolean);
    this.getPersonData()
      .then(data => {
        this.processData(data, 'personnel');
      });
    this.getOfficeData()
      .then(data => {
        this.processData(data, 'offices');
      });
  }

  /**
   * Show more results
   * @param {object} button Button from page
   */
  showMore(button) {
    let type = button.target.getAttribute('data-type');
    PARAMS[type].offset = PARAMS[type].offset + PARAMS[type].limit;
    if (type === 'personnel') {
      this.getPersonData()
        .then(data => {
          this.processData(data, type, true);
        });
    } else {
      this.getOfficeData()
        .then(data => {
          this.processData(data, type, true);
        });
    }
  }

  /**
   * Get person data from api
   * @returns {array} personnel
   */
  getPersonData() {
    return api.getPersonnel(PARAMS.personnel);
  }

  /**
   * Get office data from api
   * @returns {array} personnel
   */
  getOfficeData() {
    return api.getOffices(PARAMS.offices);
  }

  /**
   * Render html to page
   * @param {object} target HTML selector
   * @param {object} html Element that inner html will be rendered
   * @param {object} data Data that will be used to rendered html
   * @param {boolean} append Append html to target
   */
  render(target, html, data, append = false) {
    target.innerHTML = append ? target.innerHTML + Mustache.render(html.innerHTML, data) : Mustache.render(html.innerHTML, data);
  }

  /**
   * Render map to page
   * @param {object} data Data that will be used to rendered html
   */
  renderMap(data) {
    if (data.items.length > 0) {
      if (document.querySelector('html').getAttribute('lang') === 'zh') {
        BAIDU.init(this.baiduMapTarget, data.items.map((location) => {
          location.title = location.name;
          return location;
        }));
        this.baiduMapTarget.style.display = 'block';
      } else {
        this.mapTarget.style.display = 'block';
        MAP.render(this.mapTarget, data.items.map((location) => {
          location.mapLink = true;
          location.url = 'https://www.google.com/maps/dir/?api=1&destination=' + location.latitude + ',' + location.longitude;
          return location;
        }));
      }
    } else {
      this.mapTarget.style.display = 'none';
    }
  }
}
